import { getBreakpoint } from './utils.js';

const state = {};

const setState = () => {
    state.breakpoint = getBreakpoint();
};

export { state, setState };
